export function formatLabel(value: number) {
  // Trim at 1 decimal without rounding.
  return value.toFixed(2).slice(0, -1)
}
